export const progressItems = [
  {
    id: 'type',
    label: 'Door type',
    to: '/planner/type',
    placeholder: 'Door type selection is coming soon.',
  },
  {
    id: 'measure',
    label: 'Measurements',
    to: '/planner/measure',
    placeholder: 'Measurement entry is coming soon.',
  },
  {
    id: 'lock',
    label: 'Lock & Handle',
    to: '/planner/lock',
    placeholder: 'Lock and handle selection is coming soon.',
  },
  {
    id: 'colour',
    label: 'Colour',
    to: '/planner/colour',
    placeholder: 'Colour selection is coming soon.',
  },
  {
    id: 'review',
    label: 'Review',
    to: '/planner/review',
    placeholder: 'Door review is coming soon.',
  },
  { id: 'cart', label: 'Cart', to: '/cart', placeholder: 'Your cart is coming soon.' },
] as const;

export type ProgressItem = (typeof progressItems)[number];
